module.exports = __webpack_public_path__ + "static/img/down.8991e4b1.svg";